import { EmbedSessionProvider, embedSession } from './embedSession'
import { useSyncExternalStore } from 'react'

/** The CRM's name as its brokers know it, interpolated as `{{crm}}` into the `embed:*` copy. */
export const EMBED_CRM_NAMES: Record<EmbedSessionProvider, string> = {
  propstack: 'Propstack',
  onoffice: 'onOffice',
}

/**
 * The CRM whose iframe the page runs in. The live session wins, then `fallback` (a screen that knows its CRM before
 * any session exists), then the CRM of a session this page load lost. Propstack otherwise, since its embed opens the
 * session after mount.
 * @example const { provider, crmName } = useEmbedCrm()
 */
export const useEmbedCrm = (fallback?: EmbedSessionProvider): { provider: EmbedSessionProvider, crmName: string } => {
  const sessionProvider = useSyncExternalStore(embedSession.subscribe, embedSession.getProvider)
  const lastProvider = useSyncExternalStore(embedSession.subscribe, embedSession.getLastProvider)
  const provider = sessionProvider ?? fallback ?? lastProvider ?? 'propstack'

  return { provider, crmName: EMBED_CRM_NAMES[provider] }
}
